module.exports = {
	header: {
		about: '关于我们',
		game: '游戏',
		contact: '联系我们'
	},
	banner1: {
		logotitle: '你成功，所以我成功',
		logosubtitle: '',
		stoketext: '游戏创作者的联邦'
	},
	banner2: {
		indroduce: '是一个聚焦中小开发者的投资+发行平台，通过给开发者提供资金、市场、数据、发行等全方位支持，帮助中小开发者将优质的游戏带给全球玩家',
		title1: '累积发行200+ 款游戏',
		title2: '累积下载量2亿+',
		title3: '合作开发者100+'
	},
	banner3: {
		slide1: {
			title:'市场洞见',
			desc1: '提供最及时的市场信息及趋势以了解用户喜爱的玩法、题材、美术风格等。',
			desc2: '通过对标产品和市场规模分析设定合理预期。'
		},
		slide2: {
			title:'资金支持',
			desc1: '提供资金帮助开发者做出游戏',
			desc2: '资金提供形式多样，可以通过投资、版金、预付等方式获得资金。'
		},
		slide3: {
			title: '可行性验证',
			desc1: '早期针对核心玩法和美术风格进行测试验证',
			desc2: '开发者提供玩法原型及美术风格素材，我们将会通过市场进行测试验证。'
		},
		slide4: {
			title: '美术产能',
			desc1: '成熟的美术服务团队大大提升游戏的美术产能',
			desc2: '经验丰富的美术人员可以产出包括写实、卡通、漫画等各种风格的作品。'
		},
		stoketext: '增加成功率'
	},
	banner4: {
		slide1: {
			title:'用户增长',
			desc1: '快速获取高质量的用户扩大产品规模。',
			desc2: '累积超过1亿美金的投放花费及经验。'
		},
		slide2: {
			title:'商业化',
			desc1: '最大化变现收益及用户长期LTV。',
			desc2: '通过用户行为标签系统制定符合游戏生命周期的商业化策略。'
		},
		slide3: {
			title: '运营调优',
			desc1: '通过数据驱动的精细化运营促成可持续的盈利。',
			desc2: '基于用户画像行为分析，准确预判产品盈利能力。'
		},
		slide4: {
			title: '数据智能',
			desc1: '基于机器学习，提供个性化游戏内容体验。',
			desc2: '基于AI模型识进行用户分层，通过采用差异化的策略提升变现效率。'
		},
		stoketext: '放大成功规模'
	},
	banner5: {
		title: '我们的技术',
		slide1: {
			title: '深度基于机器学习',
			desc: '多条业务线进入AI阶段，预测、投放、渠道管理等多环节全面自动化智能化。 '
		},
		slide2: {
			title: 'Dataverse全球智能化数据平台',
			desc: '全球领先的用户级收益追踪媲美业界顶尖数据追踪及归因工具的效能。'
		},
		slide3: {
			title: '广告投放系统',
			desc: '智能、高效、灵活的操作广告投放，及时获得相关数据，有效提高广告展示量及转化。'
		},
		slide4: {
			title: '智能素材衍生平台',
			desc: '优秀素材经过微创新迭代，投放效能提升20%。'
		},
		slide5: {
			title: '多维度数据透视与归因',
			desc: '准确找到劣质渠道和素材，减少安装欺诈，优化投放效能与成本。'
		},
		slide6: {
			title: '实时数据跟踪',
			desc: '分钟级的数据分析及预警及时预警避免灾难性损失。'
		}
	}
	// banner1: {}
}